"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreateClient = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _reactRedux = require("react-redux");

var _reduxBatchedActions = require("redux-batched-actions");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _skybaseComponents = require("skybase-ui/skybase-components");

var _sbModal = require("skybase-ui/skybase-components/sb-modal");

var _actions = require("skybase-ui/skybase-core/base/actions");

var _withAclList = require("../../auth/with-acl-list");

var _oauthPermissions = require("../../oauth-permissions");

var _components = require("../../common/components");

var _actions2 = require("../actions");

var _utils = require("../utils");

var _constants = require("../constants");

var _shapes = require("../shapes");

var _constants2 = require("../../constants");

var _utils2 = require("../../utils");

var _validator = require("../../validator");

var _validationRules = require("../validation-rules");

var _constants3 = require("../../openid-configuration/constants");

var _constants4 = require("../../roles/constants");

var _constants5 = require("../../tenants/constants");

var _clientsI18n = require("../clients-i18n");

var _messagesI18n = require("../../messages-i18n");

var _PropTypes$shape;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var kiconnectClientsServiceReadWrite = _oauthPermissions.oAuthPermissions.kiconnectClientsServiceReadWrite,
    kiconnectClientsSystemReadWrite = _oauthPermissions.oAuthPermissions.kiconnectClientsSystemReadWrite,
    kiconnectTenantsWrite = _oauthPermissions.oAuthPermissions.kiconnectTenantsWrite;

var _CreateClient = /*#__PURE__*/function (_FormComponent) {
  (0, _inherits2.default)(_CreateClient, _FormComponent);

  var _super = _createSuper(_CreateClient);

  function _CreateClient(props) {
    var _this;

    (0, _classCallCheck2.default)(this, _CreateClient);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDataForCurrentStep", function () {
      var step = _this.state.step;
      var data = _this.props.data;
      var attributes = _this.step1Attributes;

      if (step === 2) {
        attributes = _this.step2Attributes;
      } else if (step === 3) {
        attributes = _this.step3Attributes;
      }

      return attributes.reduce(function (acc, attribute) {
        acc[attribute] = data[attribute];
        return acc;
      }, {});
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnNextStepClick", function () {
      var dataToValidate = _this.getDataForCurrentStep();

      var errors = (0, _validator.validator)(_this.validationRules, dataToValidate);

      _this.setState({
        errors: errors
      });

      if ((0, _isEmpty.default)(errors)) {
        _this.setState(function (prevState) {
          return {
            step: prevState.step + 1
          };
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnPrevStepClick", function () {
      _this.setState(function (prevState) {
        return {
          step: prevState.step - 1
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleToggleSystemClient", function (e) {
      var _this$props = _this.props,
          handleOnChangeParams = _this$props.handleOnChangeParams,
          tenantAccessPolicy = _this$props.data.tenantAccessPolicy;
      handleOnChangeParams('tenantAccessPolicy', (0, _utils.getSelectedTenant)(e.target.value, tenantAccessPolicy));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isClientCreadentialsChecked", function () {
      var allowedGrantTypes = _this.props.data.allowedGrantTypes;
      return allowedGrantTypes.indexOf(_constants.CLIENT_CREDENTIALS_GRANT_TYPE) !== -1;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderHeader", function () {
      var _this$props2 = _this.props,
          _ = _this$props2.intl.formatMessage,
          handleOverlayClick = _this$props2.handleOverlayClick;
      return /*#__PURE__*/_react.default.createElement(_sbModal.SbModalHeader, {
        title: _(_clientsI18n.messages.addNewClient),
        onCloseBtnClick: handleOverlayClick
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderBackButton", function () {
      var step = _this.state.step;
      var _ = _this.props.intl.formatMessage;

      if (step > 1) {
        return /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbButton, {
          onClick: _this.handleOnPrevStepClick
        }, _(_messagesI18n.messages.back));
      }

      return null;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderFooter", function () {
      var step = _this.state.step;
      var _this$props3 = _this.props,
          loading = _this$props3.loading,
          _ = _this$props3.intl.formatMessage;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-modal-footer fl-container fl-justify-end wizard-buttons"
      }, _this.renderBackButton(), step === _this.steps ? /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbLoaderButton, {
        loading: loading,
        className: "primary",
        onClick: _this.handleOnConfirmClick
      }, _this.confirmButtonTitle) : /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbButton, {
        className: "primary",
        onClick: _this.handleOnNextStepClick
      }, _(_messagesI18n.messages.nextStep)));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderStep1Inputs", function () {
      var _this$props4 = _this.props,
          _ = _this$props4.intl.formatMessage,
          grantTypesSupported = _this$props4.grantTypesSupported,
          tenantAccessPolicy = _this$props4.data.tenantAccessPolicy,
          aclList = _this$props4.aclList,
          allTenants = _this$props4.allTenants;
      var isSystemClient = tenantAccessPolicy === _constants.SYSTEM_CLIENT;
      var canCreateClientCredentials = aclList[kiconnectClientsServiceReadWrite];
      var canWriteTenants = aclList[kiconnectTenantsWrite];
      var canCreateSystemClient = aclList[kiconnectClientsSystemReadWrite];

      var clientCredentialsChecked = _this.isClientCreadentialsChecked();

      var grantTypesFilter = function grantTypesFilter(grantType) {
        return grantType.value !== _constants.CLIENT_CREDENTIALS_GRANT_TYPE || grantType.value === _constants.CLIENT_CREDENTIALS_GRANT_TYPE && canCreateClientCredentials;
      };

      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, _this.renderInputWithLabel('name', _(_clientsI18n.messages.clientName), {
        placeholder: _(_clientsI18n.messages.clientNamePlaceholder)
      }), _this.renderInputWithLabel('id', 'ID', {
        placeholder: _(_clientsI18n.messages.clientIdPlaceholder)
      }), _this.renderInputWithLabel('secret', _(_clientsI18n.messages.clientSecret), {
        componentType: 'password',
        placeholder: _(_clientsI18n.messages.createClientSecret),
        autoComplete: 'new-password'
      }), _this.renderButtonBarWithLabel('enabled', _(_messagesI18n.messages.enabled), [{
        title: _(_messagesI18n.messages.enabled),
        value: true
      }, {
        title: _(_messagesI18n.messages.disabled),
        value: false
      }]), _this.renderInputWithLabel('allowedGrantTypes', _(_clientsI18n.messages.allowedGrantTypes), {
        componentType: 'multiselect',
        items: grantTypesSupported.filter(grantTypesFilter)
      }), canCreateClientCredentials && canWriteTenants && /*#__PURE__*/_react.default.createElement("div", null, canCreateSystemClient && /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbLabel, {
        title: "Tenant Type"
      }, /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbButtonBar, {
        disabled: !clientCredentialsChecked
      }, /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbRadioButton, {
        checked: isSystemClient,
        onClick: _this.handleToggleSystemClient,
        value: _constants.SYSTEM_CLIENT
      }, _(_clientsI18n.messages.systemClient)), /*#__PURE__*/_react.default.createElement(_skybaseComponents.SbRadioButton, {
        checked: !isSystemClient,
        onClick: _this.handleToggleSystemClient,
        value: ""
      }, _(_clientsI18n.messages.tenantClient)))), _this.renderInputWithLabel('tenantAccessPolicy', _(_clientsI18n.messages.tenant), _objectSpread(_objectSpread({
        componentType: 'select',
        items: allTenants,
        title: _(_clientsI18n.messages.selectATenant)
      }, isSystemClient && canCreateSystemClient || !clientCredentialsChecked || allTenants.length === 0 ? {
        disabled: true
      } : {}), {}, {
        hint: _(_clientsI18n.messages.tenantHint),
        menuPosition: 'auto-top'
      }))));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderStep2Inputs", function () {
      var _ = _this.props.intl.formatMessage;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, _this.renderEditableListWithLabel('redirectUris', _(_clientsI18n.messages.redirectUris), {
        placeholder: _(_clientsI18n.messages.redirectUrisPlaceholder)
      }), _this.renderEditableListWithLabel('postLogoutRedirectUris', _(_clientsI18n.messages.postLogoutRedirectUris), {
        placeholder: _(_clientsI18n.messages.postLogoutRedirectUrisPlaceholder)
      }), _this.renderEditableListWithLabel('allowedCorsOrigins', _(_clientsI18n.messages.allowedCors), {
        placeholder: _(_clientsI18n.messages.allowedCorsPlaceholder)
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderStep3Inputs", function () {
      var _this$props5 = _this.props,
          _ = _this$props5.intl.formatMessage,
          scopesSupported = _this$props5.scopesSupported,
          roles = _this$props5.roles,
          aclList = _this$props5.aclList;
      var canCreateClientCredentials = aclList[kiconnectClientsServiceReadWrite];

      var clientCredentialsChecked = _this.isClientCreadentialsChecked();

      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, _this.renderButtonBarWithLabel('requireConsent', _(_clientsI18n.messages.requireConsent), [{
        title: _(_messagesI18n.messages.yes),
        value: true
      }, {
        title: _(_messagesI18n.messages.no),
        value: false
      }]), canCreateClientCredentials && _this.renderInputWithLabel('roles', _(_clientsI18n.messages.roles), _objectSpread({
        componentType: 'select',
        items: roles.map(function (role) {
          return {
            value: role,
            label: role
          };
        }),
        multiSelect: true,
        liveSearch: true,
        title: _(_clientsI18n.messages.selectRoles)
      }, !clientCredentialsChecked ? {
        disabled: true
      } : {})), _this.renderInputWithLabel('scopes', _(_clientsI18n.messages.scopes), {
        componentType: 'multiselect',
        items: scopesSupported
      }), _this.renderButtonBarWithLabel('allowOfflineAccess', _(_clientsI18n.messages.allowOfflineAccess), [{
        title: _(_messagesI18n.messages.yes),
        value: true
      }, {
        title: _(_messagesI18n.messages.no),
        value: false
      }]), _this.renderButtonBarWithLabel('accessTokenType', _(_clientsI18n.messages.accessTokenType), Object.values(_constants.accessTokenTypes).map(function (type) {
        return {
          title: type,
          value: type
        };
      })), _this.renderInputWithLabel('accessTokenLifetimeSeconds', _(_clientsI18n.messages.accessTokenLifetimeSeconds), {
        placeholder: _(_clientsI18n.messages.accessTokenLifetimeSecondsPlaceholder),
        type: 'number',
        addonRight: /*#__PURE__*/_react.default.createElement("div", {
          className: "addon-static-box"
        }, _(_clientsI18n.messages.seconds))
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderInputs", function () {
      var step = _this.state.step;

      switch (step) {
        case 2:
          return _this.renderStep2Inputs();

        case 3:
          return _this.renderStep3Inputs();

        default:
          return _this.renderStep1Inputs();
      }
    });
    var _2 = props.intl.formatMessage,
        _step = props.step;
    _this.state = _objectSpread(_objectSpread({}, _this.state), {}, {
      step: 1
    });
    _this.validationRules = (0, _validationRules.getValidationRules)('create', _2);
    _this.confirmButtonTitle = _step === _this.steps ? _2(_messagesI18n.messages.confirm) : _2(_messagesI18n.messages.nextStep);
    _this.isModal = true;
    _this.steps = 3;
    _this.step1Attributes = ['name', 'id', 'secret', 'enabled', 'allowedGrantTypes', 'tenantAccessPolicy'];
    _this.step2Attributes = ['redirectUris', 'postLogoutRedirectUris', 'allowedCorsOrigins'];
    _this.step3Attributes = ['requireConsent', 'roles', 'scopes', 'allowOfflineAccess', 'accessTokenType', 'accessTokenLifetimeSeconds'];
    _this.beforeConfirm = [{
      name: 'redirectUris',
      normalize: _utils2.convertFromEditableList
    }, {
      name: 'postLogoutRedirectUris',
      normalize: _utils2.convertFromEditableList
    }, {
      name: 'allowedCorsOrigins',
      normalize: _utils2.convertFromEditableList
    }, {
      name: 'secret',
      normalize: function normalize(secret) {
        return secret.trim();
      }
    }];
    return _this;
  }

  (0, _createClass2.default)(_CreateClient, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_sbModal.SbModal, {
        Header: this.renderHeader(),
        Footer: this.renderFooter(),
        width: 310,
        height: "auto",
        className: "oauth-modal"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "sb-message-modal-content"
      }, this.renderInputs()));
    }
  }]);
  return _CreateClient;
}(_components.FormComponent);

(0, _defineProperty2.default)(_CreateClient, "propTypes", _objectSpread(_objectSpread({}, _CreateClient.propTypes), {}, {
  data: _shapes.clientShape.isRequired,
  handleOverlayClick: _propTypes.default.func.isRequired,
  scopesSupported: _propTypes.default.arrayOf(_shapes.listShape).isRequired,
  grantTypesSupported: _propTypes.default.arrayOf(_shapes.listShape).isRequired,
  allTenants: _propTypes.default.arrayOf(_shapes.listShape).isRequired,
  aclList: _propTypes.default.shape((_PropTypes$shape = {}, (0, _defineProperty2.default)(_PropTypes$shape, kiconnectClientsServiceReadWrite, _propTypes.default.bool), (0, _defineProperty2.default)(_PropTypes$shape, kiconnectClientsSystemReadWrite, _propTypes.default.bool), (0, _defineProperty2.default)(_PropTypes$shape, kiconnectTenantsWrite, _propTypes.default.bool), _PropTypes$shape)).isRequired,
  roles: _propTypes.default.arrayOf(_propTypes.default.string)
}));

var mapStateToProps = function mapStateToProps(state) {
  var _getOAuthState$CLIENT = (0, _utils2.getOAuthState)(state)[_constants.CLIENTS_STATE_KEY_NAME],
      _getOAuthState$CLIENT2 = _getOAuthState$CLIENT[_constants.CLIENTS_STATE_KEYS.CREATE_CLIENT],
      data = _getOAuthState$CLIENT2.data,
      clientState = _getOAuthState$CLIENT2.state,
      _getOAuthState$CLIENT3 = _getOAuthState$CLIENT.listConfig,
      pageSize = _getOAuthState$CLIENT3.pageSize,
      pageNumber = _getOAuthState$CLIENT3.pageNumber;

  var _getOAuthState$OPENID = (0, _utils2.getOAuthState)(state)[_constants3.OPENID_CONFIGURATION_STATE_KEY_NAME],
      scopesSupported = _getOAuthState$OPENID.scopesSupported,
      grantTypesSupported = _getOAuthState$OPENID.grantTypesSupported;

  var allTenants = (0, _utils2.getOAuthState)(state)[_constants5.TENANTS_STATE_KEY_NAME].all;

  var roles = (0, _utils2.getOAuthState)(state)[_constants4.ROLES_STATE_KEY_NAME].all;

  return {
    data: data,
    loading: clientState === _constants2.STATES.LOADING,
    pageSize: pageSize,
    pageNumber: pageNumber,
    scopesSupported: scopesSupported,
    grantTypesSupported: grantTypesSupported,
    allTenants: allTenants,
    roles: roles
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var formatMessage = ownProps.intl.formatMessage;
  return {
    handleOnChangeParams: function handleOnChangeParams(attribute, value) {
      return dispatch((0, _actions2.changeCreateClientParams)(attribute, value));
    },
    handleOnConfirm: function handleOnConfirm(client, listConfig) {
      return dispatch((0, _utils.createClient)(client, listConfig, formatMessage));
    },
    handleOverlayClick: function handleOverlayClick() {
      return dispatch((0, _reduxBatchedActions.batchActions)([(0, _actions.closeModal)(), (0, _actions2.clearCreateClientParams)()]));
    }
  };
};

var withAclListComponent = (0, _withAclList.withAclList)(_CreateClient, [kiconnectClientsServiceReadWrite, kiconnectClientsSystemReadWrite, kiconnectTenantsWrite]);
var CreateClient = (0, _reactIntl.injectIntl)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(withAclListComponent));
exports.CreateClient = CreateClient;
//# sourceMappingURL=create-client.js.map